export default __webpack_public_path__ + "static/media/Carpet-Tiles.14f93166.png";